import { useEffect, useState } from "react";
import BreadCrumbs, { BreadcrumbItem } from "../../../../@ui/Breadcrumbs";
import { useLocation, useNavigate } from "react-router-dom";

const LayerBreadcrumbs = () => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathArray = location.pathname.split("/").splice(2);
    const bcs = [] as BreadcrumbItem[];
    const root = "/admin/";

    pathArray.forEach((pathItem, index) => {
      const label = decodeURI(capitalizeFirstLetter(pathItem));
      const value = root + pathArray.slice(0, index + 1).join("/");
      bcs.push({ label, value });
    });

    setBreadcrumbs(bcs);
  }, [location]);

  function capitalizeFirstLetter(str: string): string {
    if (str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <>
      {breadcrumbs.length > 0 && (
        <div className="mb-1">
          <BreadCrumbs
            items={breadcrumbs}
            onBreadcrumbClick={(url) => navigate(url)}
          />
        </div>
      )}
    </>
  );
};

export default LayerBreadcrumbs;
